<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="1"
  stroke-linecap="round"
  stroke-linejoin="round"
  class="lucide-icon lucide lucide-phidgets"
>
  <path
    class="cls-1"
    d="M18,20.82l-7.25,0A1.94,1.94,0,1,1,8.12,18.2V12.43h.6c2.73,0,5.53,0,6.52-1,.13-.13.52-.52.52-1.75a3,3,0,0,0-.58-2.08c-.82-.8-3-.82-5.24-.79V8.26a1.62,1.62,0,1,1-1.82,0V5H9.55c2.92,0,5.5-.07,6.9,1.32a4.47,4.47,0,0,1,1.12,3.36,4.08,4.08,0,0,1-1.05,3c-1.32,1.33-3.77,1.49-6.58,1.5v3.89a1.92,1.92,0,0,1,.89.89L17,19,21.9,10.4l-5-8.58L7,1.84,2.11,10.43c1,1.72,3.28,5.49,4.55,7.69a.9.9,0,0,1-.33,1.24A.91.91,0,0,1,5.09,19h0C3.4,16.11,0,10.45,0,10.45L6,0,18,0l6,10.4ZM9,8.55a1.09,1.09,0,1,0,0,2.18,1.09,1.09,0,0,0,1.09-1.09h0A1.09,1.09,0,0,0,9,8.55Zm.06,12.62a1.3,1.3,0,1,0-1.3-1.3,1.3,1.3,0,0,0,1.3,1.3"
  ></path>
</svg>
